// src/routes/AppRoutes.js
import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import receptionRoutes from "./ReceptionRoutes/ReceptionRoutes";
import pharmacyRoutes from "./PharmacyRoutes/PharmacyRoutes";
import doctorRoutes from "./DoctorRoutes/DoctorRoutes";
import nurseRoutes from "./NurseRoutes/NurseRoutes";
import xrayRoutes from "./XrayRoutes/XrayRoutes";
import ultrasoundRoutes from "./UltraSoundRoutes/UltraSoundRoutes";
import laboratoryRoutes from "./LaboratoryRoutes/LaboratoryRoutes";
import endoscopyRoutes from "./EndoscopyRoutes/EndoscopyRoutes";
import ctScanRoutes from "./CTScanRoutes/CTScanRoutes";
import mRoyRoutes from "./MRoyRoutes";
import echocardiographyRoutes from "./EchocardiographyRoutes/EchocardiographyRoutes";
import patientProfileRoutes from "./PatientProfile/PatientProfile";
import financeRoutes from "./FinanceRoutes/FinanceRoutes";
import financialManagerRoutes from "./FinanceRoutes/FinancialManagerRoutes";
import humanResourceRoutes from "./HRRoutes/HRRoutes";
import SignInView from "../pages/Authentication/SignIn/SignIn";
import dentalRoutes from "./DentalRoutes/DentalRoutes";
import CallCenterRoutes from "./CallCenterRoutes/CallCenterRoutes";
import BeautyRoutes from "./BeautyRoutes/BeautyRoutes";
import HtPatientRoutes from "./HtPatientRoutes/HtPatientRoutes";
import operationsRoutes from "./OperationsRoutes/OperationsRoutes";
import emergencyRoutes from "./EmergencyRoutes/EmergencyRoutes";
import bedManagementRoutes from "./BedManagementRoutes/BedManagementRoutes";
import ipdRoutes from "./IPDRoutes/IPDRoutes";
import icuRoutes from "./ICURoutes/ICURoutes";
import academicRoutes from "./AcademicRoutes/AcademicRoutes";
import nightShiftRoutes from "./NightShiftRoutes/NightShiftRoutes";
import reportsRoutes from "./ReportsRoutes/ReportsRoutes";

export const createAppRouter = (permissions) => {
  // Conditionally add routes based on permissions
  const childrenRoutes = [
    permissions.reception && receptionRoutes,
    permissions.pharmacy && pharmacyRoutes,
    permissions.doctor && doctorRoutes,
    permissions.nurse && nurseRoutes,
    permissions.x_ray && xrayRoutes,
    permissions.ultrasounds && ultrasoundRoutes,
    permissions.laboratory && laboratoryRoutes,
    permissions.endoscopy && endoscopyRoutes,
    permissions.ct_scan && ctScanRoutes,
    permissions.m_roy && mRoyRoutes,
    permissions.echo && echocardiographyRoutes,
    permissions.finance && financeRoutes,
    permissions.financial_manager && financialManagerRoutes,
    permissions.reports && reportsRoutes,
    permissions.hr && humanResourceRoutes,
    permissions.academic && academicRoutes,
    permissions.dental && dentalRoutes,    permissions.operations && operationsRoutes,
    permissions?.call_center && CallCenterRoutes,
    permissions?.beauty && BeautyRoutes,
    permissions?.htPatient && HtPatientRoutes,
    permissions.emergency && emergencyRoutes,
    permissions.bedManagement && bedManagementRoutes,
    permissions.ipd && ipdRoutes,
    permissions.icu && icuRoutes,
    permissions.night_shift && nightShiftRoutes,
  ].filter(Boolean);

  return createBrowserRouter([
    {
      path: "/",
      element: <App />,
      children: [...childrenRoutes, patientProfileRoutes],
    },
    { path: "/m-roy/*", element: <Navigate to="/mri" replace /> },
    { path: "user/sign-in/", element: <SignInView /> },
    { path: "*", element: <Navigate to={"/"} /> },
  ]);
};
